import { formatDurationSeconds, SlaDisplay } from '@/features/callcenter/logic';
import { cn } from '@/utils/format';

// Purely a visual affordance to draw the eye once a countdown is close to
// expiring -- NOT a server-configured SLA threshold. The actual deadline
// always comes from the payload (seconds_remaining / sla_deadline_at).
const URGENT_STYLING_THRESHOLD_SECONDS = 60;

type SlaCountdownProps = {
  display: SlaDisplay;
};

export const SlaCountdown = ({ display }: SlaCountdownProps) => {
  if (display.kind === 'held') {
    // The card itself renders the held state; nothing to show here.
    return null;
  }

  if (display.kind === 'paused') {
    return <span className="text-sm text-muted-foreground">Clock paused</span>;
  }

  if (display.kind === 'not_started') {
    return <span className="text-sm text-muted-foreground">Starts after your call</span>;
  }

  if (display.kind === 'overdue') {
    return <span className="text-sm font-semibold text-destructive">Overdue</span>;
  }

  const isUrgent = display.secondsLeft < URGENT_STYLING_THRESHOLD_SECONDS;

  return (
    <span
      className={cn(
        'font-mono text-sm tabular-nums',
        isUrgent ? 'font-semibold text-destructive' : 'text-foreground/90',
      )}
    >
      {formatDurationSeconds(display.secondsLeft)}
    </span>
  );
};
